/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.mapDispatchToProps = exports.Property = void 0;

var react_1 = __importDefault(require("react"));

var redux_1 = require("redux");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var PropertyHelper_1 = __importDefault(require("./helpers/PropertyHelper"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var DEFAULT_OPTS = {
  infoButton: 'tail'
};
var name = 'Property';
exports.name = name;

var Property = function Property(_ref) {
  var Frame = _ref.Frame,
      Image = _ref.Image,
      Text = _ref.Text,
      Radio = _ref.Radio,
      Check = _ref.Check,
      Icon = _ref.Icon,
      InfoButton = _ref.InfoButton,
      styles = _ref.styles,
      AnalyticsApi = _ref.AnalyticsApi;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
      _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
      _this.renderInfoButton = _this.renderInfoButton.bind(_assertThisInitialized(_this));
      _this.renderThumbnail = _this.renderThumbnail.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "handleClick",
      value: function handleClick(property, type, isSelected, onClick) {
        var _this$props = this.props,
            actions = _this$props.actions,
            attribute = _this$props.attribute,
            category = _this$props.category,
            select = _this$props.select,
            opts = _this$props.opts;
        var active = property.active,
            attributeId = property.attributeId,
            id = property.id,
            included = property.included;

        if (active === false || included || category.included) {
          return;
        }

        var selection = _defineProperty({}, attributeId, id);

        actions.ui.lastSelection(selection);

        if (isSelected) {
          if (type === 'check' || type === 'radio' && (opts === null || opts === void 0 ? void 0 : opts.clickAgainToDeselectRadio) && (attribute === null || attribute === void 0 ? void 0 : attribute.optional) === true) {
            AnalyticsApi.selectedProperty(selection);
            select(attributeId, null);

            if (onClick) {
              onClick(property);
            }
          }

          return;
        }

        AnalyticsApi.selectedProperty(selection);
        select(attributeId, id);

        if (onClick) {
          onClick(property);
        }
      }
    }, {
      key: "openModal",
      value: function openModal(e) {
        e.stopPropagation();
        var _this$props2 = this.props,
            actions = _this$props2.actions,
            modalData = _this$props2.modalData,
            property = _this$props2.property;
        var modalName = (property === null || property === void 0 ? void 0 : property.modal) || 'info';
        actions.ui.openModal(modalName, modalData);
      }
    }, {
      key: "renderInfoButton",
      value: function renderInfoButton() {
        return react_1.default.createElement(InfoButton, {
          onClick: this.openModal
        });
      }
    }, {
      key: "renderInput",
      value: function renderInput(property, type, isSelected) {
        switch (type) {
          case 'radio':
            return react_1.default.createElement(Radio, {
              id: "Property__input--radio--".concat(property.id),
              className: "Property__input--radio",
              disabled: property.disabled === false,
              name: "property__attribute--".concat(property.attributeId),
              isSelected: isSelected,
              style: styles === null || styles === void 0 ? void 0 : styles.radio
            });

          case 'check':
          default:
            return react_1.default.createElement(Check, {
              id: "Property__input--checkbox--".concat(property.id),
              className: "Property__input--checkbox",
              disabled: property.disabled === false,
              name: "property__attribute--".concat(property.attributeId),
              isSelected: isSelected,
              style: styles === null || styles === void 0 ? void 0 : styles.radio
            });
        }
      }
    }, {
      key: "renderPrice",
      value: function renderPrice(property, classes) {
        var _a;

        if (property.price && !property.included && ((_a = property.display) === null || _a === void 0 ? void 0 : _a.hidePrice) !== false) {
          if (property.price > 0) {
            return react_1.default.createElement(Text, {
              className: ['Property__tail-price', classes === null || classes === void 0 ? void 0 : classes.price],
              style: styles === null || styles === void 0 ? void 0 : styles.price
            }, "$", property.price.toLocaleString());
          }
        }

        return react_1.default.createElement(react_1.default.Fragment, null);
      }
    }, {
      key: "renderThumbnail",
      value: function renderThumbnail(property, env, model, classes, opts) {
        var _a, _b, _c;

        var thumbnail;

        if (property === null || property === void 0 ? void 0 : property.thumbnail) {
          var thumbnailUrl = PropertyHelper_1.default.getThumbnailUrl(env, model, property === null || property === void 0 ? void 0 : property.thumbnail) || (opts === null || opts === void 0 ? void 0 : opts.defaultThumbnail);

          if (thumbnailUrl) {
            thumbnail = react_1.default.createElement(Image, {
              className: classes === null || classes === void 0 ? void 0 : classes.thumbnail,
              src: thumbnailUrl,
              style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.thumbnail), (_a = property === null || property === void 0 ? void 0 : property.style) === null || _a === void 0 ? void 0 : _a.thumbnail)
            });
          }
        } else if ((_b = property === null || property === void 0 ? void 0 : property.display) === null || _b === void 0 ? void 0 : _b.hex) {
          thumbnail = react_1.default.createElement(Frame, {
            className: classes === null || classes === void 0 ? void 0 : classes.thumbnailColorSquare,
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.thumbnailColorSquare), {
              backgroundColor: property.display.hex
            })
          });
        }

        if (thumbnail) {
          return react_1.default.createElement(Frame, {
            className: classes === null || classes === void 0 ? void 0 : classes.thumbnailWrapper,
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.thumbnailWrapper), (_c = property === null || property === void 0 ? void 0 : property.style) === null || _c === void 0 ? void 0 : _c.thumbnailWrapper),
            onClick: this.openModal
          }, thumbnail);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _a, _b, _c, _d, _e, _f, _g, _h, _j;

        var _this$props3 = this.props,
            after = _this$props3.after,
            before = _this$props3.before,
            classes = _this$props3.classes,
            category = _this$props3.category,
            env = _this$props3.env,
            isSelected = _this$props3.isSelected,
            lastSelectedProperty = _this$props3.lastSelectedProperty,
            model = _this$props3.model,
            _onClick = _this$props3.onClick,
            _this$props3$opts = _this$props3.opts,
            opts = _this$props3$opts === void 0 ? DEFAULT_OPTS : _this$props3$opts,
            property = _this$props3.property,
            type = _this$props3.type;

        if ((property === null || property === void 0 ? void 0 : property.active) === false) {
          return react_1.default.createElement(react_1.default.Fragment, null);
        }

        var style = Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.container), (_a = property === null || property === void 0 ? void 0 : property.style) === null || _a === void 0 ? void 0 : _a.container);

        if ((property === null || property === void 0 ? void 0 : property.id) === lastSelectedProperty) {
          Object.assign(style, styles === null || styles === void 0 ? void 0 : styles.highlighted);
        }

        if (isSelected) {
          Object.assign(style, styles === null || styles === void 0 ? void 0 : styles.selected);
        }

        return react_1.default.createElement(Frame, {
          className: ['Property__container', classes === null || classes === void 0 ? void 0 : classes.container, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.pointer, !property.included && !category.included), _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.highlighted) || '', (property === null || property === void 0 ? void 0 : property.id) === lastSelectedProperty), _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.selected) || '', isSelected)],
          style: style
        }, before, react_1.default.createElement(Frame, {
          className: ['Property__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.inner), (_b = property === null || property === void 0 ? void 0 : property.style) === null || _b === void 0 ? void 0 : _b.inner),
          key: property === null || property === void 0 ? void 0 : property.id,
          onClick: function onClick(e) {
            return _this2.handleClick(property, type, isSelected, _onClick);
          }
        }, react_1.default.createElement(Frame, {
          className: ['Property__head', classes === null || classes === void 0 ? void 0 : classes.head],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.head), (_c = property === null || property === void 0 ? void 0 : property.style) === null || _c === void 0 ? void 0 : _c.head)
        }, category.included || property.included ? react_1.default.createElement(Icon, {
          className: ['Property__included-icon', classes === null || classes === void 0 ? void 0 : classes.includedIcon],
          icon: free_solid_svg_icons_1.faCheck,
          style: styles === null || styles === void 0 ? void 0 : styles.includedIcon
        }) : this.renderInput(property, type, isSelected), (property.description || property.thumbnail) && opts.infoButton === 'head' && this.renderInfoButton()), react_1.default.createElement(Frame, {
          className: ['Property__body', classes === null || classes === void 0 ? void 0 : classes.body],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.body), (_d = property === null || property === void 0 ? void 0 : property.style) === null || _d === void 0 ? void 0 : _d.body)
        }, this.renderThumbnail(property, env, model, classes, opts), react_1.default.createElement(Frame, {
          className: ['Property__body-text-container', classes === null || classes === void 0 ? void 0 : classes.textWrapper],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.textWrapper), (_e = property === null || property === void 0 ? void 0 : property.style) === null || _e === void 0 ? void 0 : _e.textWrapper),
          onClick: function onClick(e) {
            return _this2.handleClick(property, type, isSelected);
          }
        }, react_1.default.createElement(Text, {
          className: ['Property__body-text', classes === null || classes === void 0 ? void 0 : classes.bodyText],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.bodyText), (_f = property === null || property === void 0 ? void 0 : property.style) === null || _f === void 0 ? void 0 : _f.bodyText)
        }, property.name), ((_g = property.display) === null || _g === void 0 ? void 0 : _g.subtitle) && react_1.default.createElement(Text, {
          className: ['Property__body-subtitle', classes === null || classes === void 0 ? void 0 : classes.subtitle],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.subtitle), (_h = property === null || property === void 0 ? void 0 : property.style) === null || _h === void 0 ? void 0 : _h.subtitle)
        }, property.display.subtitle), (property.description || property.thumbnail) && opts.infoButton === 'body' && this.renderInfoButton())), react_1.default.createElement(Frame, {
          className: ['Property__tail', classes === null || classes === void 0 ? void 0 : classes.tail],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.tail), (_j = property === null || property === void 0 ? void 0 : property.style) === null || _j === void 0 ? void 0 : _j.tail)
        }, this.renderPrice(property, classes), (property.description || property.thumbnail) && opts.infoButton === 'tail' && this.renderInfoButton())), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Property = Property;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var propertyId = ownProps.propertyId;
  var api = state.api,
      app = state.app,
      ui = state.ui;
  var countryCode = app.countryCode,
      env = app.env;
  var configuration = api.configuration;
  var lastSelectedProperty = ui.lastSelectedProperty;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var property = db.getProperty(propertyId, {
    countryCode: countryCode
  });
  var attribute = db.getAttribute(property.attributeId);
  var category = db.getCategory(attribute.categoryId);
  var modalData = {
    property: property,
    image: property === null || property === void 0 ? void 0 : property.thumbnail,
    price: property === null || property === void 0 ? void 0 : property.price
  };
  var isSelected = configuration[property.attributeId] === propertyId;
  return {
    attribute: attribute,
    category: category,
    countryCode: countryCode,
    env: env,
    isSelected: isSelected,
    lastSelectedProperty: lastSelectedProperty,
    modalData: modalData,
    model: model,
    property: property
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    actions: {
      configuration: Object.assign({}, redux_1.bindActionCreators(brightsmith_redux_1.Actions.Configuration, dispatch)),
      ui: {
        lastSelection: redux_1.bindActionCreators(brightsmith_redux_1.Actions.Ui.lastSelection, dispatch),
        openModal: redux_1.bindActionCreators(brightsmith_redux_1.Actions.Ui.openModal, dispatch)
      }
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;

  return {
    body: Object.assign({
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _a === void 0 ? void 0 : _a.body),
    bodyText: Object.assign({
      display: 'flex',
      cursor: 'pointer'
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _b === void 0 ? void 0 : _b.bodyText),
    container: Object.assign({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginBottom: 10,
      minHeight: 33
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _c === void 0 ? void 0 : _c.container),
    inner: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: 10,
      paddingRight: 15
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _d === void 0 ? void 0 : _d.inner),
    head: Object.assign({
      alignItems: 'center',
      display: 'flex',
      textAlign: 'center'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _e === void 0 ? void 0 : _e.head),
    highlighted: Object.assign({}, (_f = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _f === void 0 ? void 0 : _f.highlighted),
    includedIcon: Object.assign({
      fontSize: 13,
      paddingLeft: 5
    }, (_g = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _g === void 0 ? void 0 : _g.includedIcon),
    pointer: Object.assign({
      cursor: 'pointer'
    }, (_h = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _h === void 0 ? void 0 : _h.pointer),
    price: Object.assign({
      fontSize: 12,
      textAlign: 'right'
    }, (_j = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _j === void 0 ? void 0 : _j.price),
    radio: Object.assign({
      borderColor: (_k = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _k === void 0 ? void 0 : _k.secondary,
      '&:checked': {
        backgroundColor: (_l = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _l === void 0 ? void 0 : _l.primary
      }
    }, (_m = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _m === void 0 ? void 0 : _m.radio),
    selected: Object.assign({}, (_o = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _o === void 0 ? void 0 : _o.selected),
    subtitle: Object.assign({
      color: (_p = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _p === void 0 ? void 0 : _p.secondary,
      fontSize: 11,
      fontStyle: 'italic',
      marginTop: 5
    }, (_q = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _q === void 0 ? void 0 : _q.subtitle),
    tail: Object.assign({
      display: 'flex',
      textAlign: 'center'
    }, (_r = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _r === void 0 ? void 0 : _r.tail),
    textWrapper: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_s = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _s === void 0 ? void 0 : _s.textWrapper),
    thumbnail: Object.assign({
      display: 'flex',
      height: 30,
      width: 'auto'
    }, (_t = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _t === void 0 ? void 0 : _t.thumbnail),
    thumbnailColorSquare: Object.assign({
      flex: 1
    }, (_u = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _u === void 0 ? void 0 : _u.thumbnailColorSquare),
    thumbnailWrapper: Object.assign({
      display: 'flex',
      justifyContent: 'center',
      marginRight: 7,
      minHeight: 30,
      minWidth: 50,
      overflow: 'hidden'
    }, (_v = theme === null || theme === void 0 ? void 0 : theme.Property) === null || _v === void 0 ? void 0 : _v.thumbnailWrapper)
  };
};

exports.style = style;